import HNSColors from "../../../ui library/HNSColors";

export const PROVIDER_DETAIL_STYLES = {
  modalSurface: {
    width: "100%",
  },
  headerBar: {
    background: `linear-gradient(
      91.64deg,
      ${HNSColors.primary[300]} -2.29%,
      ${HNSColors.primary[400]} 24.1%,
      ${HNSColors.primary[500]} 46.74%,
      ${HNSColors.tertiary[500]} 89.2%,
      ${HNSColors.tertiary[700]} 102.56%
    )`,
    boxShadow: `0px 3px 45px 0px ${HNSColors.tertiary[900]}`,
  },
  headerTitle: {
    color: HNSColors.neutrals[900],
    display: "-webkit-box",
    overflow: "hidden",
    textOverflow: "ellipsis",
    WebkitBoxOrient: "vertical",
    WebkitLineClamp: 2,
  },
  headerMetaLabel: {
    color: HNSColors.neutrals[900],
  },
  headerStatusBadge: (backgroundColor, color) => ({
    backgroundColor,
    color,
  }),
  headerRatingEmptyIcon: {
    color: HNSColors.failure[400],
  },
  headerRating: {
    "& .MuiRating-iconFilled": {
      color: HNSColors.warning[500],
    },
    "& .MuiRating-iconHover": {
      color: HNSColors.warning[500],
    },
  },
  headerActionButton: {
    alignItems: "center",
    backgroundColor: HNSColors.primary[500],
    border: "none",
    borderRadius: "10px",
    boxShadow: "none",
    color: HNSColors.neutrals[900],
    cursor: "pointer",
    display: "inline-flex",
    fontSize: "0.9375rem",
    fontWeight: 600,
    gap: "8px",
    justifyContent: "center",
    minWidth: "168px",
    padding: "10px 20px",
  },
  headerActionIcon: {
    fontSize: "18px",
  },
  contentShell: {
    backgroundColor: "transparent",
  },
  sectionCard: {
    backgroundColor: HNSColors.neutrals[900],
    border: `1px solid ${HNSColors.neutrals[800]}`,
  },
  sectionTitle: {
    color: HNSColors.neutrals[100],
  },
  primarySectionTitle: {
    color: HNSColors.primary[500],
  },
  fieldLabel: {
    color: HNSColors.neutrals[500],
  },
  fieldValue: {
    color: HNSColors.neutrals[100],
  },
  summaryDisplaySurface: {
    backgroundColor: HNSColors.neutrals[800],
    border: `1px solid ${HNSColors.neutrals[800]}`,
  },
  contactPanel: {
    backgroundColor: HNSColors.neutrals[900],
    border: `1px solid ${HNSColors.neutrals[800]}`,
  },
  contactPanelHeader: {
    backgroundColor: HNSColors.secondary[900],
  },
  contactPanelHeaderIcon: {
    color: HNSColors.secondary[400],
    fontSize: "18px",
  },
  contactPanelHeaderText: {
    color: HNSColors.secondary[400],
  },
  contactPanelAddButton: {
    alignItems: "center",
    backgroundColor: HNSColors.secondary[500],
    border: "none",
    color: HNSColors.neutrals[900],
    cursor: "pointer",
    display: "inline-flex",
    fontWeight: 600,
  },
  contactPanelAddButtonDisabled: {
    alignItems: "center",
    backgroundColor: HNSColors.neutrals[800],
    border: "none",
    boxShadow: "none",
    color: HNSColors.neutrals[500],
    cursor: "not-allowed",
    display: "inline-flex",
    fontWeight: 600,
    opacity: 1,
  },
  contactPanelAddIcon: {
    color: HNSColors.neutrals[900],
    fontSize: "18px",
  },
  contactPanelAddIconDisabled: {
    color: HNSColors.neutrals[500],
    fontSize: "18px",
  },
  contactPanelBody: {
    backgroundColor: HNSColors.neutrals[900],
  },
  contactEditorSurface: {
    backgroundColor: HNSColors.neutrals[900],
    borderColor: HNSColors.neutrals[800],
  },
  contactLabelPill: {
    backgroundColor: HNSColors.secondary[900],
    color: HNSColors.secondary[400],
  },
  contactRowDivider: {
    borderColor: HNSColors.neutrals[800],
  },
  contactEditButton: {
    padding: "6px",
  },
  contactEditIcon: {
    color: HNSColors.primary[500],
    fontSize: "18px",
  },
  contactDangerButton: {
    padding: "6px",
  },
  contactDangerIcon: {
    color: HNSColors.failure[500],
    fontSize: "18px",
  },
  emptyValue: {
    color: HNSColors.neutrals[400],
  },
  helperCard: {
    backgroundColor: HNSColors.secondary[900],
    borderColor: HNSColors.secondary[500],
  },
  helperText: {
    color: HNSColors.neutrals[400],
  },
  providerTypeChip: {
    backgroundColor: HNSColors.secondary[900],
    borderRadius: "500px",
  },
  providerTypeChipText: {
    color: HNSColors.secondary[400],
  },
  dropdownArrowIcon: {
    color: HNSColors.primary[500],
  },
  sectionVisibilityToggle: {
    alignItems: "stretch",
    backgroundColor: HNSColors.neutrals[900],
    border: `1px solid ${HNSColors.primary[700]}`,
    borderRadius: "10px",
    boxShadow: "none",
    display: "inline-flex",
    overflow: "hidden",
  },
  sectionVisibilityToggleLabel: {
    alignItems: "center",
    color: HNSColors.primary[500],
    display: "inline-flex",
    fontSize: "13px",
    fontWeight: 700,
    justifyContent: "center",
    letterSpacing: "0.01em",
    minWidth: "64px",
    padding: "0 12px 0 14px",
  },
  sectionVisibilityToggleIconPane: {
    alignItems: "center",
    backgroundColor: HNSColors.primary[500],
    color: HNSColors.neutrals[900],
    borderLeft: `1px solid ${HNSColors.primary[700]}`,
    display: "inline-flex",
    justifyContent: "center",
    minWidth: "36px",
    padding: "8px 10px",
  },
};
